import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useForm from '@/hooks/useForm';
import BrokerInformation from './components/BrokerInformation';
import ContactDetails from './components/ContactDetails';
import Security from './components/Security';
import './style.css';
import { usePost } from '@/api/hooks';
import { CreateBroker } from '@/api/endpoints/Broker/Broker';
import { errorToast } from '@/utils/toasters';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Validations } from '@/utils/validations';
import { CRIcon } from '@/components/crRender';
import { translate } from '@/utils/langUtils';
import { toolTipAtrributes } from '@/utils';
import TermsAndConditions from './popups/TermsAndConditions';

const BrokerRegistration = () => {

    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const [agreeToTerms, setAgreeToTerms] = useState(false);

    const { formDataResult, onSubmit, formHandler } = useForm();
    const modalID = useRef(null);
    const { formValues } = formHandler

    const { onPost, isLoading } = usePost(CreateBroker)

    const handleSubmit = (e) => {

        e.preventDefault();
        if (!agreeToTerms) return errorToast(t('please-agree-terms-service'));

        const { password, confirmPassword } = formValues

        if (Validations.isPasswordsMatched(password?.value, confirmPassword?.value)) return errorToast('passwords-do-not-match');

        onSubmit((d) => {
            const dataObject = {
                ...d,
                userPass: d?.password,
                nationalityId: d.nationality?.value,
                countryId: d.countryOfResidence?.value,
            }
            delete dataObject.password;
            onPost(dataObject, () => navigate('/auth/log-in'))
        })
    };


    const handleLogin = () =>
        navigate('/auth/log-in');


    const handleChangeLanguage = () => {
        var newLanguage = i18n.language == "ar" ? "en" : "ar";
        i18n.changeLanguage(newLanguage);
        SetLocStorage('i18nextLng', newLanguage)
    }


    return (
        <div className="broker-registration-container">
            <div className="broker-registration-header">
                <div className="broker-registration-header-container">
                    <div className="broker-registration-icon">
                        <Icon icon="medical-icon:administration" width="32" height="32" />
                    </div>
                    <div className="broker-registration-title-container">
                        <h1 className="broker-registration-title">{t('broker-registration')}</h1>
                        <p className="broker-registration-subtitle">
                            {t('partner-with-us-provide-seamless-health-tourism')}
                        </p>
                    </div>
                </div>
                <div {...toolTipAtrributes("change-language")} className='language-selector' onClick={handleChangeLanguage}>
                    <Icon icon={"bi:translate"} width="32" height="32" />
                </div>
            </div>

            <div >

                <BrokerInformation formHandler={formHandler} />

                <ContactDetails formHandler={formHandler} />

                <Security formHandler={formHandler} />

                <div className="broker-registration-terms">
                    <label className="broker-registration-checkbox-container" onClick={(e) => e.stopPropagation()}>
                        <input
                            type="checkbox"
                            checked={agreeToTerms}
                            onChange={(e) => setAgreeToTerms(e.target.checked)}
                            onClick={(e) => e.stopPropagation()}
                        />
                        <span className="broker-registration-checkbox-label">
                            {t('i-agree-to-the')}{' '}
                            <span className="broker-registration-link" onClick={(e) => { e.stopPropagation(); modalID.current.click() }}>{t('privacy-policy')}</span>
                            {' '}{t('and')}{' '}
                            <span className="broker-registration-link" onClick={(e) => { e.stopPropagation(); modalID.current.click() }}>{t('terms-of-service')}</span>
                        </span>
                    </label>
                </div>

                <TermsAndConditions modalID={modalID} />

                <div className="broker-registration-footer">
                    <div className="broker-registration-footer-text">
                        {t('already-have-account')}{' '}
                        <button
                            type="button"
                            className="broker-registration-login-link"
                            onClick={handleLogin}
                        >
                            {t('login')}
                        </button>
                    </div>
                    <button
                        type="submit"
                        onClick={handleSubmit}
                        className="broker-registration-submit-btn"
                        disabled={isLoading}
                    >
                        {isLoading ? translate('loading') : translate('create-account')}
                        <CRIcon isRender={!isLoading} icon="mdi:arrow-right" width="16" height="16" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BrokerRegistration;
